module.exports = __webpack_public_path__ + "static/media/ma-4.44effea8.svg";